module.exports = __webpack_public_path__ + "img/mail-disabled.b21868be.svg";